import { connect, MapStateToProps, MapDispatchToProps } from 'react-redux';
import { Props } from './FolderContentList';
import { AppState } from '../../../../../types/store';
import { getFullViewFolderIds } from '../../../../selectors/gallectionSection';

export type StateProps = Pick<Props, 'folderIds'>;
export type DispatchProps = Pick<Props, never>;
export type OwnProps = Without<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<
  StateProps,
  OwnProps,
  AppState
> = state => ({
  folderIds: getFullViewFolderIds(state),
});
const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps
);
